<div class="horizinns-container profile-container">
    <div class="card-containers">
        <ng-container *ngIf="authService.user$ | async as user; else noUser">
            <mat-card class="horizinns-card profile-card white-blur">
                <mat-card-content>
                    <div style="display: flex; flex-direction: row; align-items: center; gap: 1em;">
                        <div>
                            <img src="/assets/images/apple-touch-icon.png" style="height: 60px; width: auto;" alt="Horizinns alternate image" />
                        </div>
                        <div style="display: flex; flex-direction: column;">
                            <span style="font-weight: 650; font-size: 1.8em; color:#0d508e">{{ user.firstName}} {{ user.lastName }}</span>
                            <span style="font-size: 1.8em;color:#0d8e8c">{{ user.username }}</span>
                        </div>
                    </div>
                </mat-card-content>
            </mat-card>

            <mat-card class="horizinns-card more-blur white-blur">
                <mat-card-title>
                    <h3><i class="fa-solid fa-gear"></i> Profile Settings</h3>
                </mat-card-title>
                <mat-card-content>
                    <div class="setting-item" *ngIf="userPreference">
                        <mat-slide-toggle 
                            name="receiveMarketing"
                            id="marketingToggle"
                            color="primary"
                            [(ngModel)]="userPreference.receiveMarketing">
                            Receive Marketing Emails
                        </mat-slide-toggle>
                    </div>

                    <div class="button-row">
                        <button 
                            mat-flat-button 
                            (click)="savePreferences()" 
                            [disabled]="!isPreferenceDirty()"
                            class="metallic-text-btn-blue">
                            <i class="fa-solid fa-floppy-disk"></i>
                            Save Changes
                        </button>
                    </div>
                </mat-card-content>
            </mat-card>
        </ng-container>
        <ng-template #noUser>
            <mat-card class="profile-card">
                <mat-card-content>
                    <h3>Redirecting to login...</h3>
                </mat-card-content>
            </mat-card>
        </ng-template>
    </div>
</div>

